import { useState } from "react";
import { PetAvatar } from "@/components/PetAvatar";
import { motion, AnimatePresence } from "framer-motion";

const ReturnScreen = ({ onDismiss }) => {
  const [returnWoken, setReturnWoken] = useState(false);

  const petName = localStorage.getItem('you_pet_name') || 'your pet';
  const petType = localStorage.getItem('you_pet_type') || 'elephant';
  const petStage = parseInt(localStorage.getItem('you_pet_stage') || '1');
  const lastSession = localStorage.getItem('you_last_session_at');
  const hoursGone = lastSession
    ? (Date.now() - new Date(lastSession).getTime()) / 3_600_000
    : 0;
  const returnMood = hoursGone >= 72 ? 'sleeping' : 'lonely';

  const returnMsg = returnMood === 'sleeping'
    ? `${petName} was dreaming about you! So glad you're back!`
    : `${petName} was wondering where you went! Let's learn something!`;

  return (
    <div style={{
      minHeight: '100dvh', background: '#FFFEF9',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 24, padding: 32,
    }}>
      <div
        onClick={() => { if (!returnWoken) { setReturnWoken(true); setTimeout(onDismiss, 1200); } }}
        style={{ cursor: returnMood === 'sleeping' ? 'pointer' : 'default' }}
      >
        <div style={{
          borderRadius: '50%', padding: 24,
        }}>
          <AnimatePresence mode="wait">
            {!returnWoken ? (
              <motion.div
                key="asleep"
                initial={{ opacity: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                animate={{ scale: [1, 1.04, 1] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
              >
                <PetAvatar petType={petType} stage={petStage} mood="sleeping" size="xl" animated={false}/>
              </motion.div>
            ) : (
              <motion.div
                key="awake"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: [0.5, 1.2, 1], rotate: [0, -5, 5, 0] }}
                transition={{ duration: 0.6, ease: 'backOut' }}
              >
                <PetAvatar petType={petType} stage={petStage} mood="celebrating" size="xl" animated/>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {returnMood === 'sleeping' && !returnWoken && (
          <motion.div
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
            style={{ fontSize: 16, color: '#666666', textAlign: 'center', marginTop: 8 }}
          >
            Tap to wake {petName} up
          </motion.div>
        )}
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 24, fontFamily: "'Patrick Hand', cursive", color: '#1A1A2E', marginBottom: 8 }}>
          {returnWoken ? `${petName} is so happy!` : `Shhh...`}
        </div>
        <div style={{ fontSize: 16, color: '#555555', lineHeight: 1.6 }}>
          {returnMsg}
        </div>
      </div>

      <button
        onClick={onDismiss}
        aria-label="Continue to app"
        style={{
          background: '#448AFF',
          color: '#fff', border: 'none', borderRadius: 12,
          padding: '16px 40px', fontSize: 16, fontFamily: "'Patrick Hand', cursive",
          cursor: 'pointer',
        }}
      >
        Let's go! 🚀
      </button>
    </div>
  );
};

export default ReturnScreen;
